import React from "react";
import { Button, Paper, Skeleton, makeStyles, Add, Create, Clear, ArrowDropUp, ArrowDropDown, RemoveRedEye } from "..";
import { Link } from "react-router-dom";
var styles = makeStyles(function (theme) {
  return {
    item: {
      listStyle: "none",
      marginTop: "8px"
    },
    boxItem: {
      width: "100%",
      listStyle: "none",
      padding: "0px 16px",
      display: "inline-flex",
      alignItems: "center",
      textDecoration: "none!important",
      color: theme.palette.text.primary
    },
    titleItem: {
      flex: "1 1 auto",
      textDecoration: "none"
    },
    buttonsItem: {
      flex: "1 0 auto",
      display: "inline-flex",
      justifyContent: "flex-end"
    },
    editButton: {
      margin: "10px",
      borderColor: theme.palette.pending.main,
      color: theme.palette.pending.main
    }
  };
});

var ItemCard = function ItemCard(props) {
  var classes = styles();
  var buttonItems = [];

  if (props.variant === "item-checklist") {
    // TODO FUTURO
    if (props.isFirst) {
      buttonItems.push( /*#__PURE__*/React.createElement(Button, {
        key: "button_down_" + props.id,
        onClick: function onClick() {
          return props.itemDownClicked(props.id);
        }
      }, /*#__PURE__*/React.createElement(ArrowDropDown, null)));
    }

    if (props.isLast) {
      buttonItems.push( /*#__PURE__*/React.createElement(Button, {
        key: "button_up_" + props.id,
        onClick: function onClick() {
          return props.itemUpClicked(props.id);
        }
      }, /*#__PURE__*/React.createElement(ArrowDropUp, null)));
    }

    if (props.isInside) {
      buttonItems.push( /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        key: "button_up_" + props.id,
        onClick: function onClick() {
          return props.itemUpClicked(props.id);
        }
      }, /*#__PURE__*/React.createElement(ArrowDropUp, null)), /*#__PURE__*/React.createElement(Button, {
        key: "button_down_" + props.id,
        onClick: function onClick() {
          return props.itemDownClicked(props.id);
        }
      }, /*#__PURE__*/React.createElement(ArrowDropDown, null))));
    }

    buttonItems.push( /*#__PURE__*/React.createElement("div", {
      style: {
        margin: "0px 16px"
      },
      key: "separator_" + props.id
    }));

    if (props.isView) {
      buttonItems.push( /*#__PURE__*/React.createElement(Button, {
        key: "button_view_" + props.id,
        onClick: function onClick() {
          return props.itemViewClicked(props.id);
        },
        style: {
          margin: "10px"
        },
        variant: "outlined",
        color: "primary"
      }, /*#__PURE__*/React.createElement(RemoveRedEye, null)));
    }

    if (props.isAdd) {
      buttonItems.push( /*#__PURE__*/React.createElement(Button, {
        key: "button_add_" + props.id,
        onClick: function onClick() {
          return props.itemAddClicked(props.id);
        },
        style: {
          margin: "10px"
        },
        variant: "outlined",
        color: "primary"
      }, /*#__PURE__*/React.createElement(Add, null)));
    }

    if (props.isEditable) {
      buttonItems.push( /*#__PURE__*/React.createElement(Button, {
        key: "button_edit_" + props.id,
        onClick: function onClick() {
          return props.itemEditClicked(props.id);
        },
        className: classes.editButton,
        variant: "outlined"
      }, /*#__PURE__*/React.createElement(Create, null)));
    }

    if (props.isDelete) {
      buttonItems.push( /*#__PURE__*/React.createElement(Button, {
        key: "button_delete_" + props.id,
        onClick: function onClick() {
          return props.itemDeleteClicked(props.id);
        },
        style: {
          margin: "10px"
        },
        variant: "outlined",
        color: "secondary"
      }, /*#__PURE__*/React.createElement(Clear, null)));
    }
  } else if (props.variant === "item-template") {
    if (props.isView) {
      buttonItems.push( /*#__PURE__*/React.createElement(Button, {
        component: Link,
        to: "/templates/".concat(props.id, "/view"),
        key: "button_add_" + props.id,
        style: {
          margin: "10px"
        },
        variant: "outlined",
        color: "primary"
      }, /*#__PURE__*/React.createElement(RemoveRedEye, null)));
    }

    if (props.isEditable) {
      buttonItems.push( /*#__PURE__*/React.createElement(Button, {
        component: Link,
        to: "/templates/".concat(props.id, "/edit"),
        key: "button_edit_" + props.id,
        className: classes.editButton,
        variant: "outlined"
      }, /*#__PURE__*/React.createElement(Create, null)));
    }

    if (props.isDelete) {
      buttonItems.push( /*#__PURE__*/React.createElement(Button, {
        key: "button_delete_" + props.id,
        style: {
          margin: "10px"
        },
        variant: "outlined",
        color: "secondary",
        onClick: function onClick() {
          return props.itemDeleteClicked(props.id);
        }
      }, /*#__PURE__*/React.createElement(Clear, null)));
    }
  }

  return /*#__PURE__*/React.createElement("li", {
    key: "template-".concat(props.title),
    className: classes.item
  }, props.title ? /*#__PURE__*/React.createElement(Paper, {
    className: classes.boxItem
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.titleItem
  }, props.title), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonsItem
  }, buttonItems)) : /*#__PURE__*/React.createElement(Skeleton, null), props.children);
};

export { ItemCard };